<template>
	<el-dialog :title="titles[source]" :visible.sync="dialogVisible" width="600px" :before-close="handleClose">
		<div class="follow mb-12" v-if="source == 'talentSingle'">
			<div class="flex flex-align-center flex-just-between fz-14 yx-color-text-primary">
				<p
					><span>当前跟进人：</span><span>{{ anchor_info.partner_role_name || '-' }}</span></p
				>
				<p
					><span>跟进时间：</span><span>{{ anchor_info.cooperate_time || '-' }}</span></p
				>
				<p
					><span>合作状态：</span><span class="yx-color-primary">{{ anchor_info.cooperate_status || '-' }}</span></p
				>
			</div>
			<div class="yx-color-text-primary fz-14 flex mt-8">
				<p
					><span>待寄样</span><span class="yx-color-text-primary ml-6">{{ wait_data.wait_send_num }}</span></p
				>
				<p class="ml-30"
					><span>待收货</span><span class="yx-color-text-primary ml-6">{{ wait_data.wait_receive_num }}</span></p
				>
				<p class="ml-30"
					><span>待排期</span><span class="yx-color-text-primary ml-6">{{ wait_data.wait_plan_num }}</span></p
				>
				<p class="ml-30"
					><span>待开播</span><span class="yx-color-text-primary ml-6">{{ wait_data.wait_live_num }}</span></p
				>
			</div>
		</div>
		<h2 v-if="source == 'talentGroup'" class="mt-6 mb-16 yx-color-black fz-16">
			您已经选择
			<span class="yx-color-orange-2 fz-18">{{ drnums }}</span>
			个达人
		</h2>
		<div class="title">请选择要分配的员工，分配后由员工继续跟进合作</div>
		<div class="mb-16 flex">
			<el-input class="mr-16" v-model="partner_role_name" clearable placeholder="请输入员工名称" />
			<el-button type="primary" @click="getPartnerList">搜索</el-button>
		</div>
		<el-table :data="list" header-row-class-name="table-header-row" row-class-name="table-row">
			<el-table-column min-width="40">
				<template v-slot="{ row }">
					<el-radio v-model="to_user_id" :label="row.user_id">{{ '' }}</el-radio>
				</template>
			</el-table-column>
			<el-table-column label="员工名称" min-width="170">
				<template v-slot="{ row }">
					<div class="flex flex-align-center">
						<yx-avatar size="small" :src="row.avatar_url"></yx-avatar>
						<p class="ml-6">{{ row['partner_name'] }}</p>
						<el-tag v-if="row.deleted" type="danger" size="mini" effect="plain">账号已删除</el-tag>
						<el-tag class="ml-8" v-else-if="row.use_status === '2'" type="danger" size="mini">账号已停用</el-tag>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="mobile" label="手机号" min-width="150"></el-table-column>
			<el-table-column prop="anchor_count" label="当前跟进达人数" min-width="140"></el-table-column>
		</el-table>
		<yx-pagination
			:total="total"
			:current-page="pageInfo.page_index"
			:page-size="pageInfo.page_size"
			@size-change="sizeChange"
			@current-change="currentChange"
		/>
		<span slot="footer">
			<el-button type="primary" :loading="loading" @click="submit">确认分配</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { getPartnerList, againAllot, anchorInfo, importTalents } from '@/api/talentCRM';
import { drRoleType } from '@/utils/dataMap';
export default {
	name: 'allocationDialog',
	props: {
		drnums: {
			type: Number,
			default: 0,
		},
		platform_id: {
			type: [Number, String],
			default: 0,
		},
	},
	data() {
		return {
			dialogVisible: false,
			anchor_id: 0,
			to_user_id: 0,
			partner_role_name: '',
			list: [],
			total: 0,
			pageInfo: {
				page_index: 1,
				page_size: 20,
			},
			anchor_info: {},
			wait_data: {},
			source: '',
			titles: {
				talentSingle: '重新分配线索',
				talentGroup: '批量重新分配',
			},
			anchor_msg: [],
			loading: false,
		};
	},
	methods: {
		show(anchor_id, source, user_id) {
			this.anchor_id = anchor_id;
			this.user_id = user_id;
			this.getPartnerList();
			this.anchorInfo();
			this.dialogVisible = true;
			this.source = source;
		},
		Show(anchor_msg, source) {
			this.getPartnerList();
			this.anchor_msg = anchor_msg;
			this.dialogVisible = true;
			this.source = source;
		},
		handleClose() {
			this.anchor_id = this.to_user_id = 0;
			this.partner_role_name = '';
			this.dialogVisible = false;
		},
		async anchorInfo() {
			const { anchor_id, user_id } = this;
			const { code, data } = await anchorInfo({ anchor_id, user_id });
			if (code !== 0) return;
			this.anchor_info = data;
			this.wait_data = data.wait_data;
		},
		async getPartnerList() {
			const { partner_role_name } = this;
			const { code, data: { list = [], page = {} } = {} } = await getPartnerList({
				partnerName: partner_role_name,
				anchorId: this.anchor_id,
				...this.pageInfo,
			});
			if (code !== 0) return;
			this.list = list;
			this.total = page.item_total;
			this.to_user_id = 0;
		},
		sizeChange(size) {
			this.pageInfo.page_size = size;
			this.getPartnerList();
		},
		currentChange(index) {
			this.pageInfo.page_index = index;
			this.getPartnerList();
		},
		async submit() {
			const { anchor_id, to_user_id, platform_id } = this;
			if (!to_user_id) return this.$message.error('请选择要分配的员工');
			//单独分配
			this.loading = true;
			try {
				if (this.source === 'talentSingle') {
					await againAllot({ anchor_id, from_user_id: this.user_id, to_user_id });
					this.$message.success('分配成功');
				} else {
					const select_anchors = this.anchor_msg.map(({ anchor_id, user_id }) => ({
						anchor_id,
						from_user_id: user_id,
					}));
					await importTalents({ select_anchors, platform_id, to_user_id });
					const h = this.$createElement;
					this.$message({
						message: h('div', null, [
							h('i', { class: 'el-icon-warning', style: 'color:#2475FF;margin-right:6px' }, null),
							h('span', { style: 'color:black' }, '批量重新分配操作后，系统处理时间可能较长，您可在【分配记录】中查看分配结果'),
						]),
						type: null,
					});
				}
				this.$emit('getList');
				this.handleClose();
			} finally {
				this.loading = false;
			}
		},
	},
	components: {
		
	},
};
</script>

<style lang="less" scoped>
.title {
	font-size: 14px;
	color: #1d1f23;
	margin-bottom: 12px;
}
/deep/ .el-radio {
	margin-left: 6px;
}
/deep/ .el-radio .el-radio__label {
	display: inherit;
}
.follow {
	padding: 12px 16px;
	background: rgba(0, 83, 219, 0.03);
}
/deep/ .el-table__body-wrapper {
	height: 300px;
	overflow-y: auto;
}
/deep/ .el-dialog__body {
	padding-bottom: 0px !important;
}
/deep/ .el-dialog__footer {
	padding-top: 0px;
}
</style>
